import type { Result } from './analyticalEvaluation'
import type { DangerKind } from '$types/enums'

export type AnalyticalValue = {
	id: string
	text: string
	key: string
	name: string
	title: string
	unit: string
	extractionMethod: string
	value: number | null
	operation: string
	footnote: string
	additional: boolean
	valueError: string
	evaluation?: Record<string, Result>
	readingError?: boolean
	/** every reason this value makes the material dangerous, empty if it does not */
	danger?: DangerKind[]
}

export function DefaultAnalyticalValue(): AnalyticalValue {
	return {
		extractionMethod: '',
		footnote: '',
		key: '',
		operation: '',
		title: '',
		id: '',
		name: '',
		text: '',
		unit: '',
		value: null,
		additional: false,
		valueError: 'NONE',
		evaluation: undefined
	}
}
